module.exports = __webpack_public_path__ + "assets/img/RewardBodyBtn0.4202fedd.png";